import Vue from 'vue'
import router from '../../router/';
import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  CREATE_USER,
  EDIT_USER,
  LOAD_USERS_LIST,
} from '../const/user';
import { HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';

export default {
  namespaced: true,
  state: {
    id: localStorage.getItem('id') || '',
    token: localStorage.getItem('token') || '',
    username: localStorage.getItem('username') || '',
    role: localStorage.getItem('role') || '',
    users: [],
    balanceHistory: {
      stats: {
        total: {},
        exchanges: {},
      },
      history: [],
      pagination: {},
      loaded: null,
    },
    finishedHistory: {
      stats: {
        total: {},
        exchanges: {},
      },
      loaded: null,
    },
    balanceUsers: [],
    finishedUsers: [],
  },
  getters: {
    getRole: state => state.role,
    getToken: state => state.token,
    isAdmin: state => state.role === 'admin' || state.role === 'superadmin',
    isPartner: state => state.role === 'partner',
    isSupport: state => state.role === 'support',
    users: state => state.users,
    username: state => state.username,
  },
  actions: {
    [AUTH_LOGIN]: async ({ dispatch, commit }, { name, password, data }) => {
      const request = await dispatch(HTTP_POST, {
        method: AUTH_LOGIN,
        body: { name, password, data },
        with_token: false,
        no_commit: true,
        namespace: 'user',
      }, { root: true });

      if (request && request.data && request.data.data) {
        const data = request.data.data;
        const token = data.token;
        const user = data.user;
        localStorage.setItem('token', token);
        localStorage.setItem('id', user.id);
        localStorage.setItem('username', user.name);
        localStorage.setItem('role', user.role);

        commit(AUTH_LOGIN, {
          token,
          id: user.id,
          username: user.name,
          role: user.role,
        });
        await router.push({ name: 'ServerInfo' });
      }
    },
    [AUTH_LOGOUT]: async ({ commit }) => {
      commit(AUTH_LOGOUT);
      await router.push({ name: 'Login' });
    },
    [LOAD_USERS_LIST]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_USERS_LIST,
        namespace: 'user',
      }, { root: true });
    },
    [CREATE_USER]: async ({ dispatch }, user) => {
      const request = await dispatch(HTTP_POST, {
        method: CREATE_USER,
        namespace: 'user',
        body: user,
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [EDIT_USER]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_USER,
        namespace: 'user',
        body: data,
        replace: { id },
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
  },
  mutations: {
    [AUTH_LOGIN]: (state, { token, id, username, role }) => {
      Vue.set(state, 'token', token);
      Vue.set(state, 'id', id);
      Vue.set(state, 'username', username);
      Vue.set(state, 'role', role);
    },
    [AUTH_LOGOUT]: (state) => {
      localStorage.clear();
      Vue.set(state, 'token', '');
      Vue.set(state, 'id', '');
      Vue.set(state, 'username', '');
      Vue.set(state, 'role', '');
      Vue.set(state, 'users', []);
    },
    [LOAD_USERS_LIST]: (state, { data = {} }) => {
      if (data.users) {
        Vue.set(state, 'users', data.users);
      }
    },
  },
};
